import type { PdfEditorState } from '@urbanx/agx.ui-components2';

export const fitContractExchangeMappingFields = (editState?: PdfEditorState) =>
  editState && {
    ...editState,
    mappingFields: editState.mappingFields?.map(field => ({
      ...field,
      fitText: field.fitText ?? true,
    })),
  };
